export default __webpack_public_path__ + "static/media/fzcz_detail.55064239.png";